const SLOT_MS = 60 * 60 * 1000;
/** One bookable showing window, derived from an availability instant. */
export class ShowingSlot {
    id;
    date;
    start;
    end;
    kind;
    label;
    constructor(id, date, start, end, kind = "slot", 
    /** Optional pre-baked label (mock windows); real slots are labelled by the View. */
    label) {
        this.id = id;
        this.date = date;
        this.start = start;
        this.end = end;
        this.kind = kind;
        this.label = label;
    }
    /** Hour-long slots from availability instants; invalid instants are skipped. */
    static fromInstants(instants) {
        const out = [];
        for (const start of [...instants].sort()) {
            const d = new Date(start);
            if (Number.isNaN(d.getTime()))
                continue;
            const end = new Date(d.getTime() + SLOT_MS).toISOString();
            const date = start.slice(0, 10);
            out.push(new ShowingSlot(`${date}-${start}-${end}`, date, start, end));
        }
        return out;
    }
}
/** US phone numbers as the dealership form accepts them. */
export class UsPhone {
    static PATTERN = /^(?:\+?1[\s.-]?)?(?:\([2-9]\d{2}\)|[2-9]\d{2})[\s.-]?[2-9]\d{2}[\s.-]?\d{4}$/;
    static isValid(raw) {
        return UsPhone.PATTERN.test(raw.trim());
    }
}
//# sourceMappingURL=ShowingSlot.js.map